import {h, Fragment} from "preact"
import { AutocompleteElement } from '@nosto/preact'
import { useEffect, useState } from 'preact/hooks';
import { formatCurrency } from '../helpers'

export default ({ product }) => {
    const priceVaries = product.skus?.some(sku => sku.availability === 'InStock' && sku?.price !== product.price);
    const lowestPrice = product.skus?.reduce((obj, sku) => {
        return (sku.availability === 'InStock' && sku?.price < obj.price) ? sku : obj;
    }, product);

    return (
        <AutocompleteElement hit={product}>
            <div data-url={product.url} data-nosto-element="product" class="predictive-search__product-item line-item line-item--centered">
                <a href="javascript:void(0)" class="line-item__content-wrapper">
                    <span class="line-item__image-wrapper">
                        <img class="line-item__image"
                            src={product.imageUrl}
                            alt={product.name} />
                    </span>
                    <div class="line-item__info">
                        <div class="product-item-meta">
                            <span class="product-item-meta__title text--small">{product.name}</span>
                            {/* <span class="stamped-product-reviews-badge stamped-main-badge" data-id={product.productId} key={product.productId}></span> */}
                            <div class="klaviyo-star-rating-widget" data-id={`${product.productId}`} style="display: inline-block;"></div>
                            <div class="product-item-meta__price-list-container text--small">
                                <div class="price-list">
                                    {(lowestPrice && lowestPrice?.listPrice > lowestPrice?.price) ? (
                                        <>
                                            {priceVaries && 
                                                <small style="margin-right: 4px;"><em>from</em></small>
                                            }
                                            <span class="price price--highlight">{formatCurrency(lowestPrice?.price)}</span>
                                            <span class="price price--compare">{formatCurrency(lowestPrice?.listPrice)}</span>
                                        </>
                                    ) : (
                                        <span class="price">
                                            {priceVaries && 
                                                <small style="margin-right: 4px;"><em>from</em></small>
                                            } 
                                            {formatCurrency(lowestPrice?.price)}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right icon--direction-aware" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1.2" fill="none"></path></svg>
                </a>
            </div>
        </AutocompleteElement>
    )
}